import { node } from "prop-types";
import React from "react";

const CardPriceTitle = ({ children }) => <div className="card-price__title">{children}</div>;

CardPriceTitle.propTypes = {
	children: node.isRequired,
};

export default CardPriceTitle;
